import { defineMessages } from 'react-intl';

export const registrationInvitationErrorMessages = defineMessages({
    invitationExpiredTitle: {
        id: 'registration.invitation_expired_error_title',
        defaultMessage: 'Your Friends and Family invite link has expired.',
        description:
            'Title of the error when an invitation is expired or invalid',
    },
    invitationRedeemedTitle: {
        id: 'registration.invitation_redeemed_error_title',
        defaultMessage:
            'This Friends and Family invite link has been redeemed already.',
        description: 'Title of the error when an invitation has been redeemed',
    },
    invitationCountryTitle: {
        id: 'registration.invitation_country_error_title',
        defaultMessage: 'We are unable to update your sponsorship.',
        description:
            'Title of the error when an invitation comes from a user from another country',
    },
    subtitle: {
        id: 'registration.invitation_error_subtitle',
        defaultMessage: 'Please ask your sponsor to invite you again.',
        description: 'Subtitle of the invitation error dialog',
    },
    invitationCountrySubtitle: {
        id: 'registration.invitation_country_error_subtitle',
        defaultMessage:
            'You and the friend or family member that invited you must have the same country of residence. If you believe this is an error, please contact support.',
        description:
            'Subtitle of the error when an invitation comes from a user from another country',
    },
});
